import React, { useState } from 'react';
import styled from 'styled-components';

import { WindowDropDowns } from 'components';
import dropDownData from './dropDownData';

export const README = `INTERNET COIN — README.txt
==========================

The Internet pays dividends now.

WHAT THIS IS
------------
Internet Coin is the coin on the internet. (real)

It lives on Robinhood Chain, where the Internet's actual stocks
trade as tokens 24/7 — so for the first time, the Internet can pay
its people back.

THE MECHANIC
------------
1. 1% creator tax + pons' 1% base fee = 2% per trade, fixed at creation.
2. 1.7% of every trade goes to holders, and because the coin is quoted
   in MSFT it arrives as real tokenized Microsoft. 0.3% to pons.
3. pons' keeper airdrops it pro-rata, around the clock. No claiming.
   No dev wallet in the loop. Every tx public.

THE RULES
---------
- Fair launch. No presale. 2% per trade, can never be raised. No transfer tax. The dev
  earns nothing from trading.
- Payouts depend on trading activity. Nothing is promised. Ever.
- CA: 0x88888cC1c17FfcBa563F418c61596b3fa2Ca2e2c. Any other contract address claiming to be
  Internet Coin is FAKE. Check /ca.txt on this site.

"Where do you want to go today? Nowhere. We're holding."

est. 2025 · service pack 2
`;

export default function Notepad({ onClose }) {
  const [docText, setDocText] = useState(README);
  const [wordWrap, setWordWrap] = useState(false);

  function onClickOptionItem(item) {
    switch (item) {
      case 'Exit':
        onClose();
        break;
      case 'Word Wrap':
        setWordWrap(!wordWrap);
        break;
      case 'Time/Date':
        const date = new Date();
        setDocText(
          `${docText}${date.toLocaleTimeString()} ${date.toLocaleDateString()}`,
        );
        break;
      default:
    }
  }
  function onTextAreaKeyDown(e) {
    // handle tabs in text area
    if (e.which === 9) {
      e.preventDefault();
      e.persist();
      var start = e.target.selectionStart;
      var end = e.target.selectionEnd;
      setDocText(`${docText.substring(0, start)}\t${docText.substring(end)}`);

      // asynchronously update textarea selection to include tab
      // workaround due to https://github.com/facebook/react/issues/14174
      requestAnimationFrame(() => {
        e.target.selectionStart = start + 1;
        e.target.selectionEnd = start + 1;
      });
    }
  }

  return (
    <Div>
      <section className="np__toolbar">
        <WindowDropDowns items={dropDownData} onClickItem={onClickOptionItem} />
      </section>
      <StyledTextarea
        wordWrap={wordWrap}
        value={docText}
        onChange={e => setDocText(e.target.value)}
        onKeyDown={onTextAreaKeyDown}
        spellCheck={false}
      />
    </Div>
  );
}

const Div = styled.div`
  height: 100%;
  background: linear-gradient(to right, #edede5 0%, #ede8cd 100%);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  .np__toolbar {
    position: relative;
    height: 21px;
    flex-shrink: 0;
    border-bottom: 1px solid white;
  }
`;

const StyledTextarea = styled.textarea`
  flex: auto;
  outline: none;
  font-family: 'Lucida Console', monospace;
  font-size: 13px;
  line-height: 14px;
  resize: none;
  padding: 2px;
  ${props => (props.wordWrap ? '' : 'white-space: nowrap; overflow-x: scroll;')}
  overflow-y: scroll;
  border: 1px solid #eaff96;
`;
